module.exports = __webpack_public_path__ + "66afc1f6f78fd873a9a13e54b5bb8418.png";